import { downloadBlob } from '../../utils/download-file-utils';
import httpClient from "../http/http-client";
import { IFileDownload } from './file-download.model';

export default class FileDownloadService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getAll(reportPeriodId: string, type?: string): Promise<IFileDownload[]> {
    return this.http.get(`file-download?reportPeriodId=${reportPeriodId}${type ? type : ''}`)
      .then(response => {
        return response.data.rows
      })
      .catch(err => {
        console.log(err);
        throw err;
      })
  }

  async getAllWithPagination(reportPeriodId: string | null, type: string, page: number, perPage: number = 10, orderBy?: string, order?: 'asc' | 'desc'): Promise<{ count: number, rows: IFileDownload[] }> {
    return this.http.get(`file-download?reportPeriodId=${reportPeriodId}&type=${type}&page=${page}&perPage=${perPage}${order && orderBy ? `&orderBy=${orderBy}&order=${order}` : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      });
  }

  async getAllForCrpReport(crpReportId: string): Promise<IFileDownload[]> {
    return this.http.get(`file-download?crpReportId=${crpReportId}`)
      .then(response => {
        return response.data.rows
      })
      .catch(err => {
        console.log(err);
        throw err;
      })
  }

  async getAllForEsosAssessment(esosAssessmentId: string): Promise<IFileDownload[]> {
    return this.http.get(`file-download?esosAssessmentId=${esosAssessmentId}`)
      .then(response => {
        return response.data.rows
      })
      .catch(err => {
        console.log(err);
        throw err;
      })
  }

  async getAllForSrsReport(srsReportId: string): Promise<IFileDownload[]> {
    return this.http.get(`file-download?srsReportId=${srsReportId}`)
      .then(response => {
        return response.data.rows
      })
      .catch(err => {
        console.log(err);
        throw err;
      })
  }

  async getOne(downloadId: string): Promise<IFileDownload> {
    return this.http.get(`file-download/${downloadId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      })
  }

  async createFileDownloadEntry(type: string, reportPeriodId: string | null, analyticReportId: string | null): Promise<any> {
    return this.http.post(`file-download/create-entry`, { type: type, reportPeriodId: reportPeriodId, analyticReportId: analyticReportId })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      })
  }

  async getAllByProjectId(projectId: string, type: string, page: number, perPage: number = 10): Promise<{ count: number, rows: IFileDownload[] }> {
    return this.http.get(`file-download?projectId=${projectId}&type=${type}&page=${page}&perPage=${perPage}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      });
  }

  async downloadFile(downloadId: string, fileName: string): Promise<void> {
    try {
      const response = await this.http.get(`file-download/${downloadId}/download`, { responseType: 'blob' })
      const blob = response.data as Blob
      downloadBlob({ blob, fileName })
    } catch (err) {
      console.log(err)
      throw err
    }
  }
}